import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import '../client/i18n';
import frFR from 'antd/locale/fr_FR';
import { Spin } from 'antd';
import RiskCalculator from '@client/feature/riskCalculator';
import SharedResultsPage from '@client/feature/riskCalculator/components/SharedResultsPage';
import { ConfigProvider } from 'antd';
import theme from '@client/theme/theme';
import AppQueryClientProvider from '@client/providers/QueryClientProvider';
import { NuqsAdapter } from 'nuqs/adapters/react';

const root = document.getElementById('riskCalculator');

/**
 * Extract share token from URL path
 * Matches: /calculateur-indices-risque/s/{token}/
 * @returns {string|null} Share token or null if not a shared URL
 */
const getShareTokenFromURL = () => {
  const path = window.location.pathname;
  const match = path.match(/\/calculateur-indices-risque\/s\/([a-zA-Z0-9]+)\/?$/);
  return match ? match[1] : null;
};

/**
 * Suspense fallback for loading state
 */
const LoadingFallback = () => (
  <div className="flex justify-center items-center min-h-screen">
    <Spin size="large" />
  </div>
);

/**
 * Risk Calculator App
 * Multi-step calculator for assessing pesticide risk indices
 * Handles both normal calculator view and shared results view
 *
 * @returns {Element}
 * @constructor
 */
const RiskCalculatorApp = () => {
  const shareToken = getShareTokenFromURL();

  return (
    <NuqsAdapter>
      <AppQueryClientProvider>
        <ConfigProvider theme={theme} locale={frFR}>
          <Suspense fallback={<LoadingFallback />}>
            {shareToken ? (
              <SharedResultsPage token={shareToken} />
            ) : (
              <RiskCalculator />
            )}
          </Suspense>
        </ConfigProvider>
      </AppQueryClientProvider>
    </NuqsAdapter>
  );
};

/**
 * Render the application
 */
ReactDOM.createRoot(root).render(<RiskCalculatorApp />);
